import hasNestedValue from '@/services/functions/hasNestedValue'
import getNestedValue from '@/services/functions/getNestedValue'
import Vue from 'vue'

function getNormalizedValue (value, asObject) {
  if (asObject || value === null || typeof value !== 'object') {
    return value
  }
  return JSON.stringify(value)
}

function getValueKeyOrDefault (dataItem, valueKey, { includeKey = null, needNValue = true, asObject = false, vdefault = dataItem } = {}) {
  if (needNValue) {
    var value = null
    if (Array.isArray(valueKey)) {
      if (!valueKey.length) value = vdefault
      else {
        const obj = {}
        valueKey.forEach(key => {
          let val = getNestedValue(key, dataItem)
          if (hasNestedValue(key, dataItem) && val === undefined) val = null
          Vue.set(obj, key, val)
        })
        if (Object.entries(obj).some(([_, val]) => val === undefined)) {
          value = vdefault
        }
        value = obj
      }
    } else {
      value = hasNestedValue(valueKey, dataItem) ? getNestedValue(valueKey, dataItem) : vdefault
    }
    var includeValue = includeKey !== null ? getValueKeyOrDefault(dataItem, includeKey, { needNValue: true, asObject: true, vdefault: null }) : null
    if (includeValue !== null) {
      includeValue = typeof includeValue === 'object' ? includeValue : { [includeKey]: includeValue }
      value = typeof value === 'object' ? value : { [valueKey]: value }
      value = { ...value, ...includeValue }
    }
    return getNormalizedValue(value, asObject)
  }
  return getNormalizedValue(dataItem, asObject)
}

export default getValueKeyOrDefault
